<template lang="pug">
div(
    :class="styles.root"
)
    Tabs(
        v-if="!isOnlyQrLayout"
        v-model="activeTab"
        :list="tabs"
        :class="styles.tabs"
        @input="handleTabChange"
    )
    TransitionFade
        QRState(
            v-if="isShowQr"
            :canShare="canShare"
        )
        BankListState(
            v-else
        )
</template>

<script lang="ts">
import Vue, { computed, ref, useCssModule } from 'vue'

import { canShareFiles } from '@/packages/can-share-files'
import { sendAppEventWithRetry } from '@/packages/namba-metrics'

import { useIsOnlyQrLayout } from '@/shared/lib/hooks/useIsOnlyQrLayout'
import { Tabs } from '@/shared/ui/Tabs'
import { TransitionFade } from '@/shared/ui/transitions/TransitionFade'

import { QRState } from './QRState'
import { BankListState } from './BankListState'

export default Vue.extend({
    name: 'IdleState',
    setup() {
        const styles = useCssModule()
        const { isOnlyQrLayout } = useIsOnlyQrLayout()
        const tabs = [
            {
                id: 'fast',
                text: 'Быстрая оплата',
            },
            {
                id: 'qr',
                text: 'QR-код',
            },
        ]
        const activeTab = ref(tabs[0].id)

        const isShowQr = computed(() => {
            return (
                (!isOnlyQrLayout.value && activeTab.value === 'qr') ||
                isOnlyQrLayout.value
            )
        })

        const canShare = computed(() => {
            return !isOnlyQrLayout.value && canShareFiles()
        })

        function handleTabChange(value: 'fast' | 'qr') {
            sendAppEventWithRetry({
                name:
                    value === 'qr'
                        ? 'qrCodeButtonToggleClick'
                        : 'qrFastPaymentToggleClick',
            }).then()
        }

        return {
            isOnlyQrLayout,
            styles,
            activeTab,
            tabs,
            isShowQr,
            canShare,
            handleTabChange,
        }
    },
    components: {
        Tabs,
        QRState,
        BankListState,
        TransitionFade,
    },
})
</script>

<style module lang="scss" src="./IdleState.module.scss" />
